import { IonButton, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText, IonInput, IonSpinner } from "@ionic/react"
import Select from "react-select"
import Head from "../Header"
import Sidebar from "../Sidebar"
import DataTable from "react-data-table-component";
import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router";
import service from "../../Service/service"
import swal from 'sweetalert';
import { Modal } from "react-bootstrap";
import { searchOutline, chevronDownOutline } from "ionicons/icons";

const ResourceReport: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    const [isLoading, setIsLoading] = useState(false);
    const [id, setid] = useState('')
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);

    const [data, setData] = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [filterText1, setFilterText1] = useState("");
    const [resetPaginationToggle1, setResetPaginationToggle1] = useState(false);

    const [modalopen1, setModalopen1] = useState(false);
    const [modalopen2, setmodalopen2] = useState(false);
    const [values, setvalues] = useState([]);
    const [name,setname]=useState([])
    

    const [business, setBusiness] = useState("");
    const [department, setDeapartment] = useState("");
    const [businessUnitArr, setBusinessUnitArr] = useState([]);
    const [departmentUnitArr, setDepartmentUnitArr] = useState([]);
    const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));
    const modal = (itm: any) => {
        console.log(itm, "klll")
        setModalopen1(true)
        setid(itm)

    }
    const close = () => {
        setModalopen1(false);
        setmodalopen2(false)
        setid('')
    }
    //------------Businessunit Autocomplete-------------------//

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const [status, setstatus] = useState('');

    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };
    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Business Unit</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options = [

        ...businessUnitArr.map((state: any) => ({
            value: state.id,
            label: state.businessUnitName,
        })),
        {
            value: 'all',
            label: 'All',
        },
    ];
    const handleBusinessUnitChange = (selectedOption: any) => {
        console.log(selectedOption.value, "kn");
        setBusiness(selectedOption.value);
        ViewAllDepartmentunit(selectedOption.value);
    };

    //--------------Departmentunit Autocomplete--------------------//

    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [departmentInputValue, setDepartmentInputValue] = useState('');
    const [departmentIsFocused, setDepartmentIsFocused] = useState(false);
    const [departmentMenuIsOpen, setDepartmentMenuIsOpen] = useState(false);

    const handleDepartmentChange = (selectedOption: any) => {
        setSelectedDepartment(selectedOption);
    };

    const handleDepartmentInputChange = (inputValue: any) => {
        setDepartmentInputValue(inputValue);
    };

    const handleDepartmentMenuOpen = () => {
        setDepartmentMenuIsOpen(true);
    };

    const handleDepartmentMenuClose = () => {
        setDepartmentMenuIsOpen(false);
    };

    const handleDepartmentFocus = () => {
        setDepartmentIsFocused(true);
    };

    const handleDepartmentBlur = () => {
        setDepartmentIsFocused(false);
    };

    const DepartmentPlaceholder = () => {
        if (
            departmentInputValue === '' &&
            !selectedDepartment &&
            !departmentIsFocused
        ) {
            return <span style={{ color: "black" }}>Select Department Unit</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };
    const DepartmentDropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);
        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const departmentOptions = [
        ...departmentUnitArr.map((state: any) => ({
            value: state.id,
            label: state.departmentName,

        })),
        {
            value: 'all',
            label: 'All',
        },
    ];
    const handleDepartmentUnitChange = (selectedOption: any) => {
        setDeapartment(selectedOption.value);
    };
    const back = () => {
        history.goBack();
    }
    //-----------------------Status Autocomplete--------------------//

    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

    const handleStateChange1 = (selectedOption1: any) => {
        setSelectedOption1(selectedOption1);
    };

    const handleInputChange1 = (inputValue1: any) => {
        setInputValue1(inputValue1);
    };

    const handleMenuOpen1 = () => {
        setMenuIsOpen1(true);
    };

    const handleMenuClose1 = () => {
        setMenuIsOpen1(false);
    };

    const handleFocus1 = () => {
        setIsFocused1(true);
    };

    const handleBlur1 = () => {
        setIsFocused1(false);
    };
    const Placeholders = () => {
        if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
            return <span style={{ color: "black" }}>Select Status</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicators: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const optionss = [
        { value: '1', label: 'Active' },
        { value: '2', label: 'Inactive' },
    ]
    const handlestatusChange = (selectedOption1: any) => {
        setstatus(selectedOption1.value)
    }

    //-----------------Employee Datatable-------------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "100px",
        },
        {
            name: "Business Unit",
            sortable: true,
            // width: "100px",
            cell: (itm: any) => {
                if (itm.businessUnit && itm.businessUnit.businessUnitName !== null && itm.businessUnit.businessUnitName !== undefined) {
                    return itm.businessUnit.businessUnitName;
                } else {
                    return 'NULL';
                }
            },
            sortFunction: (a: any, b: any) => {
                const unitA = a.businessUnit && a.businessUnit.businessUnitName ? a.businessUnit.businessUnitName : '';
                const unitB = b.businessUnit && b.businessUnit.businessUnitName ? b.businessUnit.businessUnitName : '';
                return unitA.localeCompare(unitB);
            },
        },

        {
            name: "Department",
            sortable: true,
            // width: "100px",
            selector: (itm: any) => {
                if (itm.masterDepartment && itm.masterDepartment.departmentName !== null && itm.masterDepartment.departmentName !== undefined) {
                    return itm.masterDepartment.departmentName;
                } else {
                    return 'NULL';
                }
            },
            sortFunction: (a: any, b: any) => {
                const departmentA = a.masterDepartment && a.masterDepartment.departmentName ? a.masterDepartment.departmentName : '';
                const departmentB = b.masterDepartment && b.masterDepartment.departmentName ? b.masterDepartment.departmentName : '';
                return departmentA.localeCompare(departmentB);
            },
        },
        {
            name: "Employee Name",
            selector: (itm: any) => itm.name,
            sortable: true,
            sort: "name",
            width: "250px",
            cell: (itm: any) => (
                <>
                    <div className="wrapper_cls">{itm.name}{" ("}{itm.employeeCode}{")"}</div>
                </>
            )
        },
        {
            name: "Role",
            selector: (itm: any) => itm.role,
            sortable: true,
            // width: "100px",
            cell: (itm: any) => (
                <>
                    {itm.role === "TEAM_MEMBER" ? <IonText>TEAM MEMBER</IonText>
                        : itm.role === "TEAM_LEADER" ? <IonText>TEAM LEADER</IonText>
                            : itm.role === "HR" ? <IonText>HR</IonText>
                                : itm.role === "MANAGER" ? <IonText>MANAGER</IonText>
                                    : itm.role}
                </>
            )
        },
        {
            name: 'Status',
            selector: (itm: any) => itm.statusFlag,
            sortable: true,
            width: "120px",
            cell: (itm: any) => (
                <div style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {itm.statusFlag === true ? (
                        <p style={{ color: "#00b700", margin: '0' }}>ACTIVE</p>
                    ) : (
                        <p style={{ color: "red", margin: '0' }}>INACTIVE</p>
                    )}
                </div>
            )

        },
        {
            name: "Action",
            sortable: false,
            width: "100px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral", textUnderlinePosition: "under" }}>
                        <IonText onClick={() => modal(itm.id)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )
        }
    ];
    //-----------------Resource Report Api-------------------//

    const Resourceeff = (id: any) => {
       
        setModalopen1(false)
        setmodalopen2(true)
        service.ResourceEffort(id)
            .then((response) => {
                console.log(response);
                if (response.data.status == 200) {
                   
                    console.log("response.data",response)
                   
                }
                else{
                   console.log("sdsdc0")
                   setvalues(response.data)
                 
                   console.log(response.data)
                   
                }

            })
    }

    const Resourceswisereport: any = [
     
        {
            name: "S.No",
            selector: (itm: any, i: any) => i+1,
            sortable: true,
            width: "100px",
        },
        {
            name: "Project Name",
            selector: (itm: any) => itm.projectName,
            sortable: true,
            sort: "name",
            width: "250px",

        },
        {
            name: "Activity Description",
            selector: (itm: any) => (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {itm.activityEfforts.map((e: any, index: number) => (
                  <div key={index}>{e.activityDesc}</div>
                ))}
              </div>
            ),
          },
        {
            name: 'Effort-Booked',
            selector: (itm: any) => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {itm.activityEfforts.map((e: any, index: number) => (
                    <div key={index}>{e.effort}</div>
                  ))}
                </div>
              ),
        },
        {
            name: 'YTD-Effort',
            selector: (itm: any) => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {itm.activityEfforts.map((e: any, index: number) => (
                        <div key={index}>{e.ytdEffort !== null ? e.ytdEffort : 'NA'}</div>
                    ))}
                </div>
            ),
        },
        
    ];
    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

    //----------------GetAll Employeelist APi---------------//

    useEffect(() => {
        LoadEmployee();
    }, []);
    const LoadEmployee = () => {
        setIsLoading(true);
        service.HRViewEmployee()
            .then((response) => {
                console.log(response);
                console.log("Employee List", response.data.Data);

                setData(response.data.Data);


                ViewAllBusinessunit();
            })
            .catch((error) => {
                swal(error);
            })
            .finally(() => {
                setTimeout(() => {
                    setIsLoading(false);
                }, 500);
            });
    };
    const Empsort = () => {
        setIsLoading(true);
        service.SearchEmployeeByBussinessUnit(createdBy, business, department, status)
            .then((response) => {
                console.log(response);
                if (response.data.Status === "200") {
                    const responseData = response.data.Data;
                    if (responseData !== null && responseData !== undefined) {
                        setData(responseData);
                       
                    } else {
                        setData([]);
                    }
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                swal(error);
            })
            .finally(() => {
                setTimeout(() => {
                    setIsLoading(false);
                }, 500);
            });
    };

    //-------------------Dropdown BusinessUnit Api-------------------//

    const ViewAllBusinessunit = () => {
        service.GetAllBusinessUnitDropDown()
            .then((response) => {
                console.log("Bussiness Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setBusinessUnitArr(response.data.Data)
            
                }
                else {
                    setBusinessUnitArr([])
                }
            })
    }

    //-----------------Dropdown Departmentunit Api-------------------//

    const ViewAllDepartmentunit = (id: any) => {
        setDeapartment("");
        service.GetAllDepartmentUnitDropDown(id)
            .then((response) => {
                console.log("Department Unit")
                console.log(response);
                if (response.data.Status === "200") {
                    setDepartmentUnitArr(response.data.Data)
                } else {
                    setDepartmentUnitArr([])
                }
            })
    }



    //-----------------Resource Report PDF Api-------------------//

    const Resourceeffpdf = (itm: any) => {
        service.ResourceEffortPdf(id)
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    setDepartmentUnitArr(response)
                } else {
                    setDepartmentUnitArr([])
                }
            })
    }
    //--------------------Search Filter----------------------//

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );
   
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };
        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )
    }, [filterText, resetPaginationToggle]);
    const datatables = (values ?? []).filter(
        (itm: any) =>
            JSON.stringify(itm)
                .toLowerCase()
                .indexOf(filterText1.toLowerCase()) !== -1
    );
    const subHeaderComponent1 = useMemo(() => {
        const handleClear = () => {
            if (filterText1) {
                setResetPaginationToggle1(!resetPaginationToggle1);
                setFilterText1("");
            }
        };
        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText1(e.target.value)}
                            value={filterText1} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )
    }, [filterText1, resetPaginationToggle1]);
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <Modal
                    dialogClassName="modal-dialog-centered"
                    id="logouts-modal"
                    show={modalopen1}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">Resource Report</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                            <span onClick={close} aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {/* <form> */}
                        <div className="col-md-12">
                            <div className="row">
                                <button type="button" className="btn-primary btn-lg" style={{ fontSize: "15px", height: "40px", flex: 1, margin: "0 5px" }} onClick={() => Resourceeff(id)}>View Report</button>
                                <button type="button" className="btn-danger btn-lg" style={{ fontSize: "15px", height: "40px", flex: 1, margin: "0 5px" }} onClick={() => Resourceeffpdf(id)}>PDF Generate</button>
                            </div>

                        </div>
                    </div>
                </Modal>
                {/* -------------------- Modal resourse wise report--------------------- */}
                <Modal
                    dialogClassName="my-modal modal-dialog-centered"
                    show={modalopen2}>
                    <div className="modal-header">
                        <h5 className="modal-title">Resource wise Report</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                            <span onClick={close} aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {/* <form> */}
                        <div className="col-md-12">
                            <DataTable
                                columns={Resourceswisereport}
                                data={datatables}
                                pagination
                                paginationPerPage={10}
                                paginationComponentOptions={paginationComponentOptions}
                                paginationRowsPerPageOptions={[10, 20, 30]}
                                subHeader
                                subHeaderComponent={subHeaderComponent1}
                                customStyles={customStyles}
                            />
                        </div>
                    </div>
                </Modal>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} /> Resource report </h3>
                            </div>
                        </div>
                    </div>
                    <div>
                        <form className="row addmore">
                            <div className="form-group col-md-3">
                                <label style={{ fontWeight: "bold" }}>
                                    Business Unit<span className="text-danger">*</span>
                                </label>
                                <div>
                                    <Select
                                        options={options}
                                        value={options.find((option) => option.value === business) || null}
                                        onChange={handleBusinessUnitChange}
                                        onInputChange={handleInputChange}
                                        onMenuOpen={handleMenuOpen}
                                        onMenuClose={handleMenuClose}
                                        onFocus={handleFocus}
                                        onBlur={handleBlur}
                                        menuIsOpen={menuIsOpen}
                                        isSearchable
                                        placeholder={<Placeholder />}
                                        components={{
                                            DropdownIndicator: DropdownIndicator,
                                        }}
                                        className="custom-select2"
                                    />
                                </div>
                            </div>
                            <div className="form-group col-md-3">
                                <label style={{ fontWeight: "bold" }}>Department Unit <span className="text-danger">*</span></label>
                                <div>
                                    <Select
                                        options={departmentOptions}
                                        value={departmentOptions.find((option) => option.value === department) || null}
                                        onChange={handleDepartmentUnitChange}
                                        onInputChange={handleDepartmentInputChange}
                                        onMenuOpen={handleDepartmentMenuOpen}
                                        onMenuClose={handleDepartmentMenuClose}
                                        onFocus={handleDepartmentFocus}
                                        onBlur={handleDepartmentBlur}
                                        menuIsOpen={departmentMenuIsOpen}
                                        isSearchable
                                        placeholder={<DepartmentPlaceholder />}
                                        components={{
                                            DropdownIndicator: DepartmentDropdownIndicator,
                                        }}
                                        className="custom-select"
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label style={{ fontWeight: 'bold' }}>Employee Status <span className="text-danger">*</span></label>
                                    <div>
                                        <Select
                                            options={optionss}
                                            value={optionss.find((option: any) => option.value === status) || null}
                                            onChange={handlestatusChange}
                                            onInputChange={handleInputChange1}
                                            onMenuOpen={handleMenuOpen1}
                                            onMenuClose={handleMenuClose1}
                                            onFocus={handleFocus1}
                                            onBlur={handleBlur1}
                                            menuIsOpen={menuIsOpen1}
                                            isSearchable
                                            placeholder={<Placeholders />}
                                            components={{
                                                DropdownIndicator: DropdownIndicators,
                                            }}
                                            className="custom-select3"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group col-md-3">
                                <label><span className="text-danger"></span></label>
                                <div>
                                    <button onClick={() => Empsort()} type="button" className="btn btn-primary submit-btn">Search</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    {isLoading && (
                        <div
                            style={{
                                position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                            }}
                        >
                            <div >
                                <IonSpinner style={{
                                    width: "40px",
                                    height: "40px",
                                    color: "#ff8a53"
                                }} name="lines" />
                            </div>
                        </div>
                    )}
                   
                    <div className="table-responsive">
                        <DataTable
                            columns={columns}
                            data={datatable}
                            pagination
                            paginationPerPage={10}
                            paginationComponentOptions={paginationComponentOptions}
                            paginationRowsPerPageOptions={[10, 20, 30]}
                            subHeader
                            subHeaderComponent={subHeaderComponent}
                            customStyles={customStyles}
                        />
                    </div>
                
                </div>
            </IonContent>
        </IonPage>
    )
}

export default ResourceReport;